import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import CreateColorModal from "pages/de/palette/components/CreateColorModal";

const EmptyColorCard = ({ content = null, refresh = () => {} }) => {
  const [createColorVisible, setCreateColorVisible] = useState(false);

  const navigate = useNavigate();

  return (
    <SuiBox sx={{ my: 2, mx: 1 }}>
      <SuiBox
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderColor: ({ borders }) => borders.borderColor,
          cursor: "pointer",
          height: 120,
          width: "100%",
          borderRadius: 4,
        }}
      >
        {content ? (
          content
        ) : (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ height: "100%", width: "100%" }}
            onClick={() => setCreateColorVisible(true)}
          >
            <AddIcon fontSize="small" />
            <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
              Create Color
            </SuiTypography>{" "}
          </SuiBox>
        )}
      </SuiBox>
      {createColorVisible ? (
        <CreateColorModal
          handleClose={() => setCreateColorVisible(false)}
          visible={createColorVisible}
          isEdit={false}
          handleRefresh={refresh}
        />
      ) : null}
    </SuiBox>
  );
};

export default EmptyColorCard;
